import Vue from 'vue';
import VueRouter from 'vue-router';
import Layout from '@/layout/index';
import Layout1 from '@/layout1/index';
// import LayoutCompany from '@/layoutCompany/index'

Vue.use(VueRouter);

/**
 * 重写路由的push方法
 */
const routerPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch((error) => error);
};

const routes = [
  {
    path: '/',
    component: Layout,
    redirect: '/',
    children: [
      {
        path: '/',
        name: '/',
        component: () => import('../views/home/homeIndex'),
        meta: {
          title: '首页'
        }
      },
      {
        path: '/examInfo',
        name: 'examInfo',
        component: () => import('../views/examInfo/index'),
        meta: {
          title: '公告'
        }
      },
      {
        path: '/list',
        name: 'list',
        component: () => import('../views/register/list'),
        meta: {
          title: '在线报名'
        }
      },
      {
        path: '/register',
        name: 'register',
        component: () => import('../views/register/index'),
        meta: {
          title: '在线报名'
        }
      },
      {
        path: '/registerForm',
        name: 'registerForm',
        component: () => import('../views/register/registerForm'),
        meta: {
          title: '在线报名填写'
        }
      },
      {
        path: '/query',
        name: 'query',
        component: () => import('../views/register/query'),
        meta: {
          title: '报名查询'
        }
      },
      {
        path: '/queryScore',
        name: 'queryScore',
        component: () => import('../views/register/queryScore'),
        meta: {
          title: '成绩查询'
        }
      },
      {
        path: '/ticketIndex',
        name: 'ticketIndex',
        component: () => import('../views/ticket/ticketIndex'),
        meta: {
          title: '准考证打印'
        }
      },
      {
        path: '/userCenter',
        name: 'userCenter',
        component: () => import('../views/user/userCenter'),
        meta: {
          title: '准考证打印'
        }
      }
    ]
  },
  ,
  {
    path: '/loginIndex1',
    component: Layout1,
    children: [
      {
        path: '/loginIndex',
        name: 'loginIndex',
        component: () => import('../views/login/loginIndex'),
        meta: {
          title: '登录'
        }
      },
      {
        path: '/forgetPwd',
        name: 'forgetPwd',
        component: () => import('../views/login/forgetPassword'),
        meta: {
          title: '忘记密码'
        }
      },
      {
        path: '/reg',
        name: 'reg',
        component: () => import('../views/login/register'),
        meta: {
          title: '注册'
        }
      }
    ]
  },
  {
    path: '/queryGrade',
    name: 'QueryGrade',
    component: () => import('../views/hhba/index'),
    meta: {
      title: '在线查询成绩'
    }
  },
  {
    path: '/grade',
    name: 'Grade',
    component: () => import('../views/hhba/grade'),
    meta: {
      title: '考试成绩查询'
    }
  }
];

const router = new VueRouter({
  routes,
  scrollBehavior() {
    return {
      x: 0,
      y: 0
    };
  }
});
export default router;
